module.exports = __webpack_public_path__ + "static/vendor-withdrawal-form-492ad7e3a8cd12936b8e4f9ca90b180c.png";